var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProjectSetupFormRemoveLanguage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 25,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#project_setup_form_remove_language_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m19 7.004-1.41-1.41-5.59 5.59-5.59-5.59L5 7.004l5.59 5.59L5 18.184l1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "project_setup_form_remove_language_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .594h24v24H0z"
})))));
export default SvgProjectSetupFormRemoveLanguage;